import { graphql, useStaticQuery } from 'gatsby';

export const query = graphql`
    query BlogEntryHeroQuery {
        site {
            siteMetadata {
                siteUrl
            }
        }
    }
`;

type Metadata = {
    site: {
        siteMetadata: {
            siteUrl: string;
        };
    };
};

export default function useSiteUrl(): string {
    const {
        site: {
            siteMetadata: { siteUrl },
        },
    } = useStaticQuery<Metadata>(query);

    return siteUrl;
}
